/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:58:03
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/divider.js
 */
export default {
    // divider组件
    divider: {
        dashed: false,
        hairline: true,
        dot: false,
        textPosition: 'center',
        text: '',
        textSize: 14,
        textColor: '#909399',
        lineColor: '#dcdfe6'
    }

}
